export const events = [
    { title: 'Visit Houston',   url: 'https://www.visithoustontexas.com',                  img: 'https://i.imgur.com/dfpKhKR.png', kind: 'Official' },
    { title: 'City Cast',       url: 'https://houston.citycast.fm',                        img: 'https://i.imgur.com/Woj5nSY.png', kind: 'Newsletter' },
    { title: 'Do 713',          url: 'https://do713.com',                                   img: 'https://i.imgur.com/ai6NIqC.png', kind: 'Calendar' },
    { title: 'Culture Map',     url: 'https://houston.culturemap.com/events/',              img: 'https://i.imgur.com/HTzldVF.png', kind: 'Magazine' },
    { title: 'Meetup',          url: 'https://www.meetup.com/find/us--tx--houston/',        img: 'https://i.imgur.com/zGHM8Sg.png', kind: 'Community' },
    { title: 'Eventbrite',      url: 'https://www.eventbrite.com/d/tx--houston/events/',    img: 'https://i.imgur.com/kyGsgjf.png', kind: 'Tickets' },
    { title: 'AllEvents',       url: 'https://allevents.in/houston',                        img: 'https://i.imgur.com/FTqRS4x.png', kind: 'Calendar' },
]

export const schedules = [
    { title: 'Performing Arts', url: 'https://performingartshouston.org',                  img: 'https://i.imgur.com/OCgvdlK.png', kind: 'Theatre' },
    { title: 'Downtown +',      url: 'https://downtownhouston.org/calendar',               img: 'https://i.imgur.com/P9ptuic.png', kind: 'District' },
    { title: 'POST Events',     url: 'https://www.posthtx.com/event',                      img: 'https://i.imgur.com/gL3H34H.png', kind: 'Rooftop' },
    { title: 'Ion District',    url: '#',                                                   img: 'https://i.imgur.com/M6HCiGa.png', kind: 'Innovation' },
    { title: 'G. R. Brown',     url: 'https://www.grbhouston.com/attendees/events-calendar/', img: 'https://i.imgur.com/1BJiG1v.png', kind: 'Convention' },
    { title: 'Houston Zoo',     url: 'https://www.houstonzoo.org/plan-your-visit/calendar/', img: 'https://i.imgur.com/G1I7Sgu.png', kind: 'Family' },
    { title: 'MFA Houston',     url: 'https://www.mfah.org/calendar',                      img: 'https://i.imgur.com/WybC8rn.png', kind: 'Museum' },
]

export const community = [
    { title: 'Black Book Houston', url: 'https://www.blackbookhouston.com',                img: 'https://i.imgur.com/ynPgN09.png', kind: 'Directory' },
    { title: 'BLD PWR',            url: 'https://www.bldpwr.com',                          img: 'https://i.imgur.com/ZPBTmYx.png', kind: 'Advocacy' },
    { title: 'LOUD Muzik',         url: 'https://loudmuzik.com',                           img: 'https://i.imgur.com/kiAkQv6.png', kind: 'Music' },
    { title: 'Volunteer Houston',  url: 'https://volunteerhouston.org',                    img: 'https://i.imgur.com/3MI9AGM.png', kind: 'Civic' },
    { title: 'Michelin Guide',     url: 'https://guide.michelin.com/us/en/texas/houston',  img: 'https://i.imgur.com/IaYIBOa.png', kind: 'Recognition' },
]

export const tickets = [
    { title: 'Live Nation',  url: 'https://specialevents.livenation.com/venues/houston',   img: 'https://i.imgur.com/wF0iVa6.png', kind: 'Venues' },
    { title: 'Stub Hub',     url: 'https://www.stubhub.com',                               img: 'https://i.imgur.com/f8bLO5y.png', kind: 'Resale' },
    { title: 'Seat Geek',    url: 'https://seatgeek.com/cities/houston',                   img: 'https://i.imgur.com/oLv5aih.png', kind: 'Resale' },
    { title: 'Ticketmaster', url: 'https://www.ticketmaster.com',                          img: 'https://i.imgur.com/UkMdAeC.png', kind: 'Primary' },
    { title: 'Vivid Seats',  url: 'https://www.vividseats.com',                            img: 'https://i.imgur.com/QctOxuI.png', kind: 'Resale' },
]

export const music = tickets;

export const sports = [
    { title: 'Astros',       url: 'https://www.mlb.com/astros/',                           img: 'https://i.imgur.com/9j3HfVB.png', kind: 'MLB',        venue: 'Daikin Park',          season: 'Apr – Oct' },
    { title: 'Rockets',      url: 'https://www.nba.com/rockets/',                          img: 'https://i.imgur.com/0zT6xMN.png', kind: 'NBA',        venue: 'Toyota Center',        season: 'Oct – Apr' },
    { title: 'Texans',       url: 'https://www.houstontexans.com',                         img: 'https://i.imgur.com/4h87O9I.png', kind: 'NFL',        venue: 'NRG Stadium',          season: 'Sep – Jan' },
    { title: 'Dynamo',       url: 'https://www.houstondynamofc.com/',                      img: 'https://i.imgur.com/YfS8vmd.png', kind: 'MLS',        venue: 'Shell Energy Stadium', season: 'Feb – Oct' },
    { title: 'Dash',         url: 'https://www.houstondynamofc.com/houstondash',           img: 'https://i.imgur.com/rSFOceC.png', kind: 'NWSL',       venue: 'Shell Energy Stadium', season: 'Mar – Nov' },
    { title: 'LOVB Houston', url: 'https://www.lovb.com/teams/lovb-houston-volleyball',    img: 'https://i.imgur.com/rZF0nCd.png', kind: 'Volleyball', venue: 'Fertitta Center',      season: 'Jan – Mar' },
]

export const creators = [
    {
        name: 'Shawn Singh',
        handle: '@shawnthefoodsheep',
        beat: 'Restaurants',
        picked: 12,
        img: 'https://i.imgur.com/irEpt1v.png',
        links: {
            youtube: 'https://www.youtube.com/channel/UCjNSnDIV9CKG5P-Vb9oltgQ',
            tiktok: 'https://www.tiktok.com/@shawnthefoodsheep',
            instagram: 'https://www.instagram.com/shawnthefoodsheep/',
            facebook: 'https://www.facebook.com/shawnthefoodsheep',
            snapchat: 'https://www.snapchat.com/add/thefoodsheep?share_id=MkFFNTkx&locale=en_US',
            pinterest: 'https://pin.it/6Laqf81',
        }
    },
    {
        name: 'Mark Waits',
        handle: '@markdallaswaits',
        beat: 'Around town',
        picked: 6,
        img: 'https://i.imgur.com/gKoJXyQ.png',
        links: {
            youtube: 'https://youtu.be/Fc8GGePAVqg?si=6H3dEOMydD24UnU3',
            tiktok: 'https://www.tiktok.com/@markdallaswaits',
            instagram: 'https://www.instagram.com/markdallaswaits/'
        }
    },
    {
        name: 'Daniel',
        handle: '@danielfromtinktonk',
        beat: 'Honest reviews',
        picked: 4,
        img: 'https://i.imgur.com/nY6Mpu6.png',
        links: {
            youtube: 'https://www.youtube.com/@danielfromyoutube',
            tiktok: 'https://tiktok.com/@danielfromtinktonk'
        }
    },
    {
        name: 'Jasmeen',
        handle: '@jasmeentriedit',
        beat: 'Things to try',
        picked: 5,
        img: 'https://i.imgur.com/VAJDi3F.png',
        links: {
            tiktok: 'https://www.tiktok.com/@jasmeentriedit',
            instagram: 'https://instagram.com/jasmeentriedit?igshid=MzRlODBiNWFlZA=='
        }
    },
    {
        name: 'Hungry in Houston',
        handle: '@hungry_inhouston',
        beat: 'Hidden spots',
        picked: 7,
        img: 'https://i.imgur.com/AK2jXan.png',
        links: {
            youtube: 'https://www.youtube.com/@hungry_inhouston?si=y5Zj1TomdORxcK0S',
            tiktok: 'https://www.tiktok.com/@hungry_inhouston'
        }
    },
    {
        name: 'Tami Smith',
        handle: '@tamicami1e',
        beat: 'Travel & food',
        picked: 4,
        img: 'https://i.imgur.com/ZRq109H.png',
        links: {
            tiktok: 'https://www.tiktok.com/@tamicami1e',
            instagram: 'https://www.instagram.com/tamicami1e',
            twitter: 'https://x.com/tamicami1e/status/1644761780206333958'
        }
    },
    {
        name: 'Wayne Dang',
        handle: '@waynedang',
        beat: 'Asian eats',
        picked: 9,
        img: 'https://i.imgur.com/Nqj7s8U.png',
        links: {
            youtube: 'https://www.youtube.com/@dangitswayne',
            tiktok: 'https://www.tiktok.com/@waynedang',
            instagram: 'https://www.instagram.com/dangitswayne/',
            facebook: 'http://www.facebook.com/dangitswayne',
            twitter: 'https://twitter.com/wayniedang'
        }
    },
    {
        name: 'GoodEatsWithRy',
        handle: '@goodeatswithry',
        beat: 'Date-night spots',
        picked: 5,
        img: 'https://i.imgur.com/HBOJ90E.png',
        links: {
            tiktok: 'https://www.tiktok.com/@goodeatswithry_/',
            instagram: 'https://www.instagram.com/goodeatswithry_/'
        }
    },
    {
        name: 'Houston Hotspots',
        handle: '@houstonhotspots',
        beat: 'Nightlife',
        picked: 3,
        img: 'https://i.imgur.com/TwNHGZW.png',
        links: {
            tiktok: 'https://www.tiktok.com/@houstonhotspots'
        }
    },
    {
        name: 'Where to Next?',
        handle: '@wheretogonext___',
        beat: 'Itineraries',
        picked: 4,
        img: 'https://i.imgur.com/RL9RuOX.png',
        links: {
            tiktok: 'https://www.tiktok.com/@wheretogonext___'
        }
    },
    {
        name: 'Foodie HTx',
        handle: '@foodiehtx5',
        beat: 'Late-night',
        picked: 2,
        img: 'https://i.imgur.com/BUn2lGJ.png',
        links: {
            tiktok: 'https://www.tiktok.com/@foodiehtx5'
        }
    },
    {
        name: 'Melly Mack',
        handle: '@thymetravelerswife2',
        beat: 'Family-friendly',
        picked: 3,
        img: 'https://i.imgur.com/cw40yEw.png',
        links: {
            tiktok: 'https://www.tiktok.com/@thymetravelerswife2'
        }
    },
    {
        name: 'Allie',
        handle: '@prettygirleatshouston',
        beat: 'Plates worth posting',
        picked: 8,
        img: 'https://i.imgur.com/8RRHdnH.png',
        links: {
            youtube: 'https://youtube.com/channel/UCbGl2kIazNKe9BhwTOj716w',
            tiktok: 'https://www.tiktok.com/@prettygirleatshouston',
            instagram: 'https://instagram.com/prettygirleatshouston',
            facebook: 'https://www.facebook.com/Prettygirleatshouston/',
            snapchat: 'https://t.snapchat.com/kn888qS0'
        }
    },
    {
        name: 'Eric Eats HTX',
        handle: '@ericeats',
        beat: 'Steaks & sushi',
        picked: 6,
        img: 'https://i.imgur.com/81Tffun.png',
        links: {
            youtube: 'https://www.youtube.com/@Ericeatshtx',
            tiktok: 'https://www.tiktok.com/@ericeats',
            instagram: 'https://www.instagram.com/ericeatshtx',
            facebook: 'https://www.facebook.com/people/EricEats/100088811126960/',
            twitter: 'https://x.com/EricEatsHTX'
        }
    },
    {
        name: 'Eyez of Chaz',
        handle: '@eyezofchaz',
        beat: 'Photo-first',
        picked: 4,
        img: 'https://i.imgur.com/wWBnvKv.png',
        links: {
            tiktok: 'https://www.tiktok.com/@eyezofchaz'
        }
    },
    {
        name: 'Diamond Monae',
        handle: '@diamonddmonaee4',
        beat: 'Soulful eats',
        picked: 5,
        img: 'https://i.imgur.com/UuDOfkw.png',
        links: {
            youtube: 'https://youtu.be/ZKRY_rE6eb4?si=aAhdFbnxiopEfU0M',
            tiktok: 'https://www.tiktok.com/t/ZTRfx6M7G/',
            instagram: 'https://www.instagram.com/diamonddmonaee',
            snapchat: 'https://snapchat.com/t/La15fQOS'
        }
    },
]
